"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonContainer = exports.Body = exports.Title = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _widths = require("../../../styles/widths");

var _palette = require("../../../styles/palette");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var Container = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  font-family: Montserrat;\n  overflow:auto\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding: ", "px ", "px;\n  background: ", ";\n  color: ", ";\n  &>div {\n    width: 100%;\n    text-align: left;\n    max-width: 892px;\n  }  \n"])), _widths.widths.base * 4, _widths.widths.base * 2, _palette.palette.darkWhite, _palette.palette.bobBlack);

exports.Container = Container;
Container.displayName = 'Container';

var Title = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  font-weight: bold;\n  font-size: 20px;\n  line-height: ", "px;\n  color: #070E2C;\n  text-align: left;\n"])), _widths.widths.base * 4);

exports.Title = Title;
Title.displayName = 'Title';

var Body = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 24px;\n  color: #070E2C;\n  margin: ", "px 0px;\n"])), _widths.widths.base * 2);

exports.Body = Body;
Body.displayName = 'Body';

var ButtonContainer = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: center;\n"])));

exports.ButtonContainer = ButtonContainer;
ButtonContainer.displayName = 'ButtonContainer';